module.exports = __webpack_public_path__ + "img/firebase.c589356a.png";